import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const DAYS = ["V", "H", "K", "Sze", "Cs", "P", "Szo"];
const W = 260;
const H = 56;

export const PeakSparkline = () => {
  const [data, setData] = useState(null);
  const [hover, setHover] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/player-peaks`).then((r) => alive && setData(Array.isArray(r.data) ? r.data : [])).catch(() => alive && setData([]));
    return () => { alive = false; };
  }, []);

  if (!data || data.length === 0) return null;

  const max = Math.max(1, ...data.map((d) => d.peak));
  const pts = data.map((d, i) => ({
    x: (i / (data.length - 1)) * W,
    y: H - 6 - (d.peak / max) * (H - 12),
    ...d,
  }));
  const path = pts.map((p, i) => `${i ? "L" : "M"}${p.x},${p.y}`).join(" ");
  const area = `${path} L${W},${H} L0,${H} Z`;
  const active = hover ?? pts.length - 1;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 1.3, ease: [0.22, 1, 0.36, 1] }}
      className="mt-5 inline-flex flex-col gap-2 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 backdrop-blur-md"
      data-testid="peak-sparkline"
    >
      <div className="flex items-center justify-between gap-6 font-mono text-[11px]">
        <span className="tracking-[0.2em] uppercase text-white/45">7 napos csúcs</span>
        <span className="text-white" data-testid="peak-sparkline-value">
          {pts[active].peak} <span className="text-white/40">játékos · {pts[active].date.slice(5).replace("-", ".")}</span>
        </span>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} width={W} height={H} className="overflow-visible" onMouseLeave={() => setHover(null)}>
        <defs>
          <linearGradient id="peakFill" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="rgb(94,177,255)" stopOpacity="0.35" />
            <stop offset="100%" stopColor="rgb(94,177,255)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <motion.path d={area} fill="url(#peakFill)" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2, duration: 0.8 }} />
        <motion.path
          d={path}
          fill="none"
          stroke="rgb(94,177,255)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 1.4, delay: 1.5, ease: "easeOut" }}
        />
        {pts.map((p, i) => (
          <g key={p.date} onMouseEnter={() => setHover(i)} data-testid={`peak-point-${i}`}>
            <rect x={p.x - W / 14} y={0} width={W / 7} height={H} fill="transparent" />
            <circle cx={p.x} cy={p.y} r={i === active ? 3.5 : 2} fill={i === active ? "#fff" : "rgb(94,177,255)"} className="transition-all duration-300" />
            <text x={p.x} y={H + 12} textAnchor="middle" fontSize="9" fill={i === active ? "#fff" : "rgba(255,255,255,0.35)"} fontFamily="JetBrains Mono">
              {DAYS[new Date(p.date).getDay()]}
            </text>
          </g>
        ))}
      </svg>
      <span className="h-2" />
    </motion.div>
  );
};
